var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreerisckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3415 24.22C23.7535 24.22 28.9515 19.0221 28.9515 12.61C28.9515 6.19798 23.7535 1 17.3415 1C10.9294 1 5.73145 6.19798 5.73145 12.61C5.73145 19.0221 10.9294 24.22 17.3415 24.22Z",
    stroke: "black",
    strokeWidth: 0.157156,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3415 24.22C23.7535 24.22 28.9515 19.0221 28.9515 12.61C28.9515 6.19798 23.7535 1 17.3415 1C10.9294 1 5.73145 6.19798 5.73145 12.61C5.73145 19.0221 10.9294 24.22 17.3415 24.22Z",
    stroke: "#29ABE2",
    strokeWidth: 0.817211,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35077 27.7236H0.462158V36.0007H5.35077V27.7236Z",
    stroke: "#F39200",
    strokeWidth: 0.785779,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28687 28.2276H8.78647L11.2863 25.8389H19.619C21.508 26.5702 22.1848 27.7805 21.1743 29.7274H23.7853L30.7293 26.5056C30.7293 26.5056 32.3402 25.7277 33.2292 26.6167C34.1181 27.5057 34.2845 27.7831 34.2845 27.7831C35.0262 29.3552 34.0954 30.3951 32.0624 31.4772C30.6182 32.3384 24.7854 35.3935 24.7854 35.3935L5.2872 35.6157",
    stroke: "#F39200",
    strokeWidth: 0.785779,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5074 25.2832V28.6717",
    stroke: "#F39200",
    strokeWidth: 0.345743,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3959 27.3379V24.0605",
    stroke: "#F39200",
    strokeWidth: 0.345743,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3959 22.8399V21.8398",
    stroke: "#F39200",
    strokeWidth: 0.345743,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7749 19.4802C13.9152 19.2884 12.5527 17.6761 12.4757 15.2961H14.1837C14.2797 16.9274 15.2584 17.9449 17.3697 17.9449C19.3273 17.9449 20.4596 17.1771 20.4596 15.6419C20.4596 14.3369 19.7112 13.7608 18.2523 13.4539L16.2946 13.0319C14.1643 12.5713 12.9359 11.4581 12.9359 9.40441C12.9359 7.3507 14.356 5.94965 16.7746 5.73879V4.16504H18.0796V5.7582C20.4017 6.00755 21.9564 7.54315 21.9758 9.71166H20.2678C20.1908 8.25305 19.2313 7.29347 17.3506 7.29347C15.7578 7.29347 14.6636 7.98428 14.6636 9.40475C14.6636 10.4985 15.3354 11.0746 16.7555 11.4006L18.5786 11.8229C20.8817 12.3605 22.2061 13.4352 22.2061 15.6422C22.2061 17.8492 20.5938 19.2502 18.0796 19.4614V21.0543H16.7746V19.4805H16.7749V19.4802Z",
    fill: "#F39200"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreerisckIcon);
export default __webpack_public_path__ + "static/media/freerisckIcon.e2afe7fb340a81b760ec0e2290fd2c94.svg";
export { ForwardRef as ReactComponent };